/**
 * Tiny store for the shared-element (card poster -> detail poster) transition.
 * The card records its on-screen rect on click; the detail poster performs a
 * FLIP animation from that rect. Robust across route changes and scroll.
 */
let last = null;

export function setSharedOrigin(id, el) {
  if (!el) return;
  const r = el.getBoundingClientRect();
  last = { id, rect: { left: r.left, top: r.top, width: r.width, height: r.height }, t: Date.now() };
}

export function takeSharedOrigin(id) {
  if (!last || last.id !== id || Date.now() - last.t > 1600) return null;
  // Not cleared here (StrictMode runs effects twice); expires by time or clearSharedOrigin().
  return last.rect;
}

export function clearSharedOrigin() {
  last = null;
}
